/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Full_Mock_3_DetailInputs */

const en_cap_full_mock_3_detail = /** @type {(inputs: Cap_Full_Mock_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budgets, fallbacks, every call recorded`)
};

const lv_cap_full_mock_3_detail = /** @type {(inputs: Cap_Full_Mock_3_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budžeti, rezerves ceļi, katrs izsaukums pierakstīts`)
};

/**
* | output |
* | --- |
* | "Budgets, fallbacks, every call recorded" |
*
* @param {Cap_Full_Mock_3_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_full_mock_3_detail = /** @type {((inputs?: Cap_Full_Mock_3_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Full_Mock_3_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_full_mock_3_detail(inputs)
	return en_cap_full_mock_3_detail(inputs)
});